export const findPromotionProductListIndex = (products, productId) =>
  products.findIndex((p, index) => `${p.id}-${index}` === productId);

export const shiftProductErrorsAfterRemove = (errors, removedIndex, prefix) => {
  if (!errors || removedIndex < 0) return errors || {};
  const next = { ...errors };
  const pattern = new RegExp(`^${prefix}_(\\d+)_(.+)$`);
  const matched = Object.keys(next)
    .map((key) => {
      const m = key.match(pattern);
      if (!m) return null;
      return {
        key,
        idx: parseInt(m[1], 10),
        suffix: m[2],
        value: next[key],
      };
    })
    .filter(Boolean);

  matched.forEach(({ key, idx }) => {
    if (idx === removedIndex) {
      delete next[key];
    }
  });

  matched
    .filter(({ idx }) => idx > removedIndex)
    .sort((a, b) => b.idx - a.idx)
    .forEach(({ key, idx, suffix, value }) => {
      delete next[key];
      next[`${prefix}_${idx - 1}_${suffix}`] = value;
    });

  return next;
};

export const clearProductErrorsAtIndex = (errors, index, prefix) => {
  if (!errors || index < 0) return errors || {};
  const next = { ...errors };
  const pattern = new RegExp(`^${prefix}_${index}_`);
  Object.keys(next).forEach((key) => {
    if (pattern.test(key)) {
      delete next[key];
    }
  });
  return next;
};

/** Clear specific product field errors (e.g. pricing, offerPrice, type, group). */
export const clearProductErrorKeys = (errors, index, prefix, suffixes = []) => {
  if (!errors || index < 0 || !suffixes.length) return errors || {};
  const next = { ...errors };
  let changed = false;
  suffixes.forEach((suffix) => {
    const key = `${prefix}_${index}_${suffix}`;
    if (next[key]) {
      delete next[key];
      changed = true;
    }
  });
  return changed ? next : errors;
};
